"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StandardForm = StandardForm;
var _react = _interopRequireWildcard(require("react"));
var _wmStandardFormContainer = _interopRequireDefault(require("../wm-standard-form-container"));
var _reactLoading = _interopRequireDefault(require("react-loading"));
var _api = _interopRequireDefault(require("../../services/api"));
require("./styles.css");
var _fieldTypes = require("../../constants/field-types");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function StandardForm(props) {
  //PROPS
  var _props = _objectSpread({}, props),
    descriptor = _props.descriptor,
    altRenders = _props.altRenders,
    onSave = _props.onSave,
    onError = _props.onError,
    onCancel = _props.onCancel,
    biRef = _props.biRef;
  //STATE
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    initialForm = _useState4[0],
    setInitialForm = _useState4[1];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var _useState7 = (0, _react.useState)(props.id),
    _useState8 = _slicedToArray(_useState7, 2),
    id = _useState8[0],
    setId = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = _slicedToArray(_useState9, 2),
    fields = _useState10[0],
    setFields = _useState10[1];
  var _useState11 = (0, _react.useState)(),
    _useState12 = _slicedToArray(_useState11, 2),
    prePatch = _useState12[0],
    setPrePatch = _useState12[1];
  var _useState13 = (0, _react.useState)(),
    _useState14 = _slicedToArray(_useState13, 2),
    patch = _useState14[0],
    setPatch = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showError = _useState16[0],
    setShowError = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    loading = _useState18[0],
    setLoading = _useState18[1];
  //OTHERS
  var showButtons = (fields === null || fields === void 0 ? void 0 : fields.length) > 0;
  (0, _react.useEffect)(function () {
    function getInfos() {
      return _getInfos.apply(this, arguments);
    }
    function _getInfos() {
      _getInfos = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var infos, keys;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(id && descriptor !== null && descriptor !== void 0 && descriptor.baseUrl && fields)) {
                _context.next = 8;
                break;
              }
              _context.next = 3;
              return _api.default.get(baseUrlWithId(descriptor.baseUrl, id));
            case 3:
              infos = _context.sent;
              keys = Object.keys(fields);
              setInitialForm(populateForm(keys, infos || {}, fields));
              _context.next = 9;
              break;
            case 8:
              setInitialForm({});
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _getInfos.apply(this, arguments);
    }
    getInfos();
  }, [id, descriptor, fields]);
  (0, _react.useEffect)(function () {
    if (descriptor !== null && descriptor !== void 0 && descriptor.fields) {
      var auxFields = descriptor.fields;
      if (altRenders) {
        var keys = Object.keys(altRenders);
        keys.forEach(function (key) {
          var index = auxFields.findIndex(function (field) {
            return field.name === key;
          });
          var newDesc = altRenders[key];
          newDesc.type = newDesc.type || _fieldTypes.CUSTOM;
          newDesc.name = newDesc.name || key;
          if (index >= 0) auxFields[index] = newDesc;else auxFields.push(newDesc);
        });
      }
      setFields(auxFields);
    }
  }, [descriptor]);
  (0, _react.useEffect)(function () {
    setId(props.id);
  }, [props.id]);
  (0, _react.useEffect)(function () {
    console.log(errors);
  }, [errors]);
  (0, _react.useEffect)(function () {
    function savePatch() {
      return _savePatch.apply(this, arguments);
    }
    function _savePatch() {
      _savePatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var auxPatch, code, key;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(patch && descriptor !== null && descriptor !== void 0 && descriptor.autoSave)) {
                _context2.next = 17;
                break;
              }
              _context2.prev = 1;
              if (id) {
                _context2.next = 6;
                break;
              }
              handleSave();
              _context2.next = 8;
              break;
            case 6:
              _context2.next = 8;
              return _api.default.patch(baseUrlWithId(descriptor.baseUrl, id), patch);
            case 8:
              _context2.next = 17;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);
              auxPatch = _objectSpread({}, patch);
              code = "autoSaveError.document";
              while (auxPatch.constructor.name === "Object") {
                key = Object.keys(auxPatch)[0];
                console.log(key);
                code += "." + key;
                auxPatch = auxPatch[key];
              }
              console.log(code);
              populateError({
                code: code,
                message: "falha no salvamento automatico"
              });
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 10]]);
      }));
      return _savePatch.apply(this, arguments);
    }
    savePatch();
  }, [patch]);
  function populateErrorHelper(path, error) {
    if (path.indexOf(".") < 0) return _defineProperty({}, path, {
      message: error.message,
      hasError: true
    });
    return _defineProperty({}, path.substring(0, path.indexOf(".")), populateErrorHelper(path.substring(path.indexOf(".") + 1), error));
  }
  function populateError(error) {
    var code = error.code,
      message = error.message;
    if (code.indexOf(".") < 0) {
      setShowError(message);
    } else {
      var path = code.substring(code.indexOf(".") + 1);
      path = path.substring(path.indexOf(".") + 1);
      var name = path.indexOf(".") === -1 ? path : path.substring(0, path.indexOf("."));
      path = path.substring(path.indexOf(".") + 1);
      setErrors(function (errors) {
        var pathErrors = populateErrorHelper(path, error);
        if (path !== name) pathErrors = _defineProperty({}, name, _objectSpread(_objectSpread({}, pathErrors), errors[name]));
        return _objectSpread(_objectSpread({}, errors), pathErrors);
      });
    }
  }
  function populateForm(keys, infos, fields) {
    var newForm = {};
    keys.forEach(function (key) {
      if (fields[key].type !== _fieldTypes.COMPLEX) newForm[fields[key].name] = infos[fields[key].name];else if (infos[fields[key].name]) newForm[fields[key].name] = populateForm(Object.keys(fields[key].fields), infos[fields[key].name], fields[key].fields);
    });
    return newForm;
  }
  function handleSave() {
    return _handleSave.apply(this, arguments);
  }
  function _handleSave() {
    _handleSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var res, errorFlag, data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setLoading(true);
            _context3.prev = 1;
            setErrors({});
            setShowError(null);
            if (id) {
              _context3.next = 12;
              break;
            }
            _context3.next = 7;
            return _api.default.postForm(descriptor === null || descriptor === void 0 ? void 0 : descriptor.baseUrl, form);
          case 7:
            res = _context3.sent;
            setId(res.id);
            onSave(res.id);
            _context3.next = 16;
            break;
          case 12:
            if (descriptor !== null && descriptor !== void 0 && descriptor.autoSave) {
              _context3.next = 16;
              break;
            }
            _context3.next = 15;
            return _api.default.putForm(baseUrlWithId(descriptor === null || descriptor === void 0 ? void 0 : descriptor.baseUrl, id), form);
          case 15:
            onSave(id);
          case 16:
            _context3.next = 25;
            break;
          case 18:
            _context3.prev = 18;
            _context3.t0 = _context3["catch"](1);
            errorFlag = true;
            console.log(_context3.t0);
            if (_context3.t0.response) {
              data = _context3.t0.response.data;
              if (data && data.errors) {
                errorFlag = false;
                data.errors.forEach(function (error) {
                  return populateError(error);
                });
              }
            }
            if (errorFlag) setShowError("Erro ao salvar");
            onError();
          case 25:
            setLoading(false);
          case 26:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 18]]);
    }));
    return _handleSave.apply(this, arguments);
  }
  function baseUrlWithId(baseUrl, id) {
    return baseUrl.includes("{id}") ? baseUrl.replace("{id}", id) : baseUrl + "/" + id;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "wm-sf-container " + (descriptor === null || descriptor === void 0 ? void 0 : descriptor.containerClass)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "wm-sf-title " + (descriptor === null || descriptor === void 0 ? void 0 : descriptor.titleClass)
  }, descriptor === null || descriptor === void 0 ? void 0 : descriptor.label), /*#__PURE__*/_react.default.createElement(_wmStandardFormContainer.default, _extends({
    biRef: biRef,
    fields: fields || [],
    onChange: function onChange(form) {
      return setForm(form);
    },
    onPrePatchChange: function onPrePatchChange(prePatch) {
      return setPrePatch(prePatch);
    },
    onPatchChange: function onPatchChange(patch) {
      return setPatch(patch);
    },
    errors: errors,
    initialForm: initialForm,
    editable: !id
  }, props)), showError && /*#__PURE__*/_react.default.createElement("span", {
    className: "wm-standard-error wm-general-error"
  }, showError), showButtons && /*#__PURE__*/_react.default.createElement("div", {
    className: "wm-save-cancel-buttons-container"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      if (onCancel) onCancel();else window.history.back();
    },
    className: "wm-sf-cancel-button " + (descriptor === null || descriptor === void 0 ? void 0 : descriptor.cancelButtonClass)
  }, "Cancelar"), !loading ? /*#__PURE__*/_react.default.createElement("button", {
    onClick: handleSave,
    disabled: patch === prePatch && (descriptor === null || descriptor === void 0 ? void 0 : descriptor.autoSave) && !loading,
    className: "wm-sf-save-button " + (descriptor === null || descriptor === void 0 ? void 0 : descriptor.saveButtonClass)
  }, "Salvar") : /*#__PURE__*/_react.default.createElement(_reactLoading.default, {
    type: "spin",
    color: "black",
    height: 20,
    width: 20
  })));
}
StandardForm.defaultProps = {
  descriptor: {},
  altRenders: {},
  onSave: function onSave() {},
  onError: function onError() {},
  onCancel: null,
  biRef: {},
  id: null
};
StandardForm.propTypes = {
  descriptor: _propTypes.default.object,
  altRenders: _propTypes.default.object,
  onSave: _propTypes.default.func,
  onError: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  biRef: _propTypes.default.object,
  id: _propTypes.default.number
};